import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { increaseFormPage, setFormPage } from '../../../reactive/actions';
import { vars } from '../../../reactive';
import FormChoice from '../../../components/FormChoice/FormChoice';
import { FORM_CHOICE_COMPONENT_TYPES, FORM_CHOICE_TYPES } from '../../../components/FormChoice/types';
import { FORM_PAGES } from '../../../components/Form/types';

const FormBookingRecurrenceType = () => {
  const formOptions = useForm();
  const { control } = formOptions;
  const type = FORM_CHOICE_TYPES.RECURRENCE;
  const { registerAs } = FORM_CHOICE_COMPONENT_TYPES[type];
  const product = vars.selectedProduct()!;

  const data = useWatch({ name: `choice_${registerAs}`, control });

  useEffect(() => {
    if (!data) {
      return;
    }
    vars.selectedOrderGroupSlots([{ slots: [] }]);
    vars.recurrenceType(data);
    increaseFormPage();
  }, [data]);

  return (
    <FormChoice
      type={type}
      formOptions={formOptions}
      previousPage={{
        onPrevious: () => {
          let newPage = FORM_PAGES.PRODUCTS;

          if (Object.values(product?.customizations || {})?.length) {
            newPage = FORM_PAGES.PRODUCT_CUSTOMIZATIONS;
          }

          setFormPage(newPage);
        }
      }}
    />
  );
};
export default FormBookingRecurrenceType;
